<template>
  <div class="row">
    <div class="container mx-auto p-8 flex">
      <div class="max-w-md w-full mx-auto">
        <h1 class="text-4xl text-center mb-12 font-thin">{{ pageTitle }}</h1>

        <div class="bg-white rounded-lg overflow-hidden shadow-2xl">
          <div class="p-8">
            <form @submit.prevent="signin()" action="/" method="post">
              <div class="mb-5">
                <label for="email" class="block mb-2 text-sm font-medium text-gray-600"
                  >Email</label
                >

                <input
                  type="text"
                  name="email"
                  id="email"
                  v-model="email"
                  class="block w-full p-3 rounded bg-gray-200 border border-transparent focus:outline-none"
                />
              </div>

              <div class="mb-5">
                <label for="password" class="block mb-2 text-sm font-medium text-gray-600"
                  >Password</label
                >

                <input
                  type="password"
                  name="password"
                  id="password"
                  v-model="password"
                  class="block w-full p-3 rounded bg-gray-200 border border-transparent focus:outline-none"
                />
              </div>

              <button class="w-full p-3 mt-4 bg-blue-600 text-white rounded shadow">Login</button>
            </form>
          </div>
          <alert v-if="msg" :msg="msg" :classAlert="classAlert"></alert>
          <div class="flex justify-between p-8 text-sm border-t border-gray-300 bg-gray-100">
            <a href="#" class="font-medium text-blue-500">Create account</a>

            <a href="#" class="text-gray-600">Forgot password?</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "../../shared/Alert";

export default {
  computed: {
    pageTitle() {
      return process.env.VUE_APP_NAME;
    },
  },
  data() {
    return {
      token: null,
      expires_in: null,
      email: "",
      password: "",
      msg: null,
      classAlert: null,
    };
  },
  components: {
    Alert,
  },
  created() {
    if (this.$store.getters.loginState) {
      this.$router.push({ name: "Admin" });
    }
  },
  methods: {
    signin() {
      const auth = {
        username: process.env.VUE_APP_CLIENT_ID,
        password: "testsecret",
      };
      const form = new FormData();

      form.append("username", this.email);
      form.append("password", this.password);
      form.append("grant_type", "password");

      console.log("form", auth);
      this.$guest
        .post("/login", form, { auth })
        .then((res) => {
          this.msg = "You have been successfully logged in!";
          this.classAlert = "success";
          this.email = "";
          this.password = "";

          this.token = res.data.access_token;
          this.expires_in = res.data.expires_in;
          const expiresMs = this.expires_in * 1000;
          const now = new Date();
          const expireDate = new Date(now.getTime() + expiresMs);
          localStorage.setItem("token", this.token);
          localStorage.setItem("expires", expireDate);
          this.$store.dispatch("login", expiresMs);
          this.$router.push({ name: "Admin" });
        })
        .catch((err) => {
          console.log(err);

          this.msg = err.response.data.error_description;
          this.classAlert = "danger";
        });
    },
  },
};
</script>

<style></style>
